export const NAME = 'dialogs';
export default NAME;
